import styled from "styled-components";

export const Dash = styled.p`
  height: 40px;
  display: flex;
  width: 100%;
  font-size: 15px;
  margin-bottom: 0;
  align-items: center;
  padding-left: 22px;
`;
